<template>
  <div>
    <div class="container-logo">
      <div class="logo-empresa" :style="`background-image: url('${base_assets}/capa.jpeg')`">
        <div style="background-color: rgba(0,0,0,0.3); height: 100%; width: 100%; border-radius: 0 0 42px 42px;">
          <div class="container text-center">
            <img class="img-empresa shadow-top" :src="`${base_assets}/favicons/android-icon-512x512.png`" alt="Logo da empresa">
          </div>
        </div>
      </div>
    </div>
    <div class="homepage">
      <div class="container-home">
        <div class="container">
          <h6 class="mb-3 text-center">Selecione uma unidade</h6>
          <div v-for="e in unidades" :key="e.id_empresa">
            <a href="/home" @click="selecionar(e.token)">
              <div class="lista media text-dark not-decoration align-items-center">
                <div class="media-body my-2">
                  <h4 class="h6 m-0 text-dark">{{e.nome_fantasia}}</h4>
                  <p class="m-0 small">
                    {{e.endereco}}, {{e.numero}}
                  </p>
                  <p class="mb-1 small">
                    {{e.bairro}}, {{e.nome_cidade}} - {{e.sigla_estado}}
                  </p>
                  <div>
                    <span class="badge border mr-1" v-if="e.tipo_delivery === '1'"><span class="mr-1">🛵</span> Delivery</span>
                    <span class="badge border mr-1" v-if="e.tipo_delivery === '1'"><span class="mr-1">📌</span> Retirar no Local</span>
                    <span class="badge border" v-if="e.tipo_delivery === '2'"><span class="mr-1">📌</span> Apenas para retirada</span>
                    <span class="badge border" v-if="e.tipo_delivery === '3'"><span class="mr-1">🛵</span> Apenas Delivery</span>
                  </div>
                </div>
                <div class="my-1 position-relative" style="margin-left: 12px">
                  <img :src="e.url_imagem" aria-hidden="true" alt="empresa">
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container text-center mb-4">
      <ads-le-card hide-ads="true"/>
    </div>
  </div>
</template>

<script>
  import AdsLeCard from "../../../components/AdsLeCard";

  export default {
    name: 'Franquia',
    components: {AdsLeCard},
    data() {
      return {
        load: true,
        token: localStorage.getItem('token'),
      }
    },

    methods: {
      selecionar(empresa) {
        localStorage.setItem('empresa_default', empresa);
      }
    },

    mounted() {
      if (!this.franquiasEnabled) {
        this.$router.push('/home');
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      unidades() {
        return this.$store.state.unidades;
      }
    },
  }
</script>
<style scoped>
  .media img {
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 50%;
    display: inline-block;
    padding: 4px;
    border: 1px solid #dee2e6;
  }

  .lista {
    cursor: pointer;
    padding: 8px 10px;
    margin-bottom: 12px;
    background-color: #ffffff;
    border-radius: 18px;
    box-shadow: var(--shadow);
  }

  .container-home {
    width: 100%;
    max-width: 560px;
    margin: 0 auto 62px;
  }

  .container-logo {
    position: relative;
    height: 188px;
    margin-bottom: 82px;
    margin-top: -1rem;
  }

  .logo-empresa {
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: var(--lecard-primary)!important;
    border-radius: 0 0 42px 42px;
  }

  .img-empresa {
    margin-top: 128px;
    object-fit: cover;
    width: 120px;
    height: 120px;
    background-color: var(--lecard-primary)!important;
    border: 6px solid #fff;
    border-radius: 50%;
  }
</style>
